import { Injectable } from '@angular/core';
import { catchError, Observable, of, tap } from 'rxjs';
import { RiskLevelItem } from '../types/risk-config.model';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RiskLevelService {
  constructor(private http: HttpClient) { }

  private readonly url = `${environment.API_INSPEC}RiskLevel`

  private cache: Map<string, RiskLevelItem[]> = new Map();
  private dataLoaded = false

  getRiskLevelItems(customerId: string): Observable<RiskLevelItem[]> {
    return this.http.get<RiskLevelItem[]>(this.url + `/GetRiskLevelItems?customerId=${customerId}`);
  }

  getRiskLevelItem(id: string): Observable<RiskLevelItem> {
    return this.http.get<RiskLevelItem>(this.url + `/${id}`);
  }

  getCachedRiskLevelItems(customerId: string): Observable<RiskLevelItem[]> {
    if (this.cache.has(customerId)) {
      console.log('Returning data from cache for customer:', customerId);
      return of(this.cache.get(customerId)!);
    }
    return this.fetchAndCacheRiskLevelItems(customerId);
  }

  private fetchAndCacheRiskLevelItems(customerId: string): Observable<RiskLevelItem[]> {
    return this.http.get<RiskLevelItem[]>(`${this.url}/GetRiskLevelItems?customerId=${customerId}`).pipe(
      tap(items => {
        this.cache.set(customerId, items);
        this.dataLoaded = true;
      }),
      catchError(error => {
        console.error('Failed to fetch items', error);
        return of([] as RiskLevelItem[]);
      })
    );
  }

  postRiskLevelItem(riskLevelItem: RiskLevelItem) {
    return this.http.post<{ id: string }>(this.url, riskLevelItem);
  }

  putRiskLevelItem(riskLevelItem: RiskLevelItem) {
    return this.http.put(this.url, riskLevelItem);
  }

  deleteRiskLevelItem(id: string) {
    return this.http.delete<boolean>(this.url + `?id=${id}`);
  }

  getRiskLevelFromMatrix(customerId: string, pofId: string, consequenceId: string): Observable<RiskLevelItem> {
    const params = new HttpParams()
      .set('customerId', customerId)
      .set('pofId', pofId)
      .set('consequenceId', consequenceId);

    return this.http.get<RiskLevelItem>(`${this.url}/GetRiskLevelFromMatrix`, { params });
  }
}
